// extracted by mini-css-extract-plugin
module.exports = {"category-tabs-container":"style_category-tabs-container__PRbeG","tab-item":"style_tab-item__bE7Nm","active":"style_active___BaYC"};